import React, {useEffect, useState} from 'react';
import {Breadcrumb} from "react-bootstrap";
import { useLocation } from "react-router-dom"

const Toolbar = () => {
    const [pathName, setPathName] = useState('');
    let history = useLocation()
    const updatePath = () => {
        setPathName(window.location.pathname)
    }
    useEffect(() => {
        updatePath()
    },[history])

    return (
        <React.Fragment>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
                             data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
                             className="page-title d-flex align-items-center flex-wrap ms-5 mb-5 mb-lg-0">

                            {
                                pathName === '/' &&
                                <h1 className="d-flex align-items-center text-dark fw-bolder my-2 fs-4">داشبورد</h1>
                            }
                            {
                                pathName === '/services' &&
                                <Breadcrumb className={"f-12 py-2"}>
                                    <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                    <Breadcrumb.Item active className={"text-muted"}>
                                        سرویس ها
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            }
                            {
                                pathName === '/wallet' &&
                                <Breadcrumb className={"f-12 py-2"}>
                                    <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                    <Breadcrumb.Item active className={"text-muted"}>
                                        تراکنش های ریالی
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            }
                            {
                                pathName === '/tickets' &&
                                <Breadcrumb className={"f-12 py-2"}>
                                    <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                    <Breadcrumb.Item active className={"text-muted"}>
                                        تیکت ها
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            }{
                            pathName === '/factors' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    فاکتورها
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/factors/payment') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item href="/factors">
                                    فاکتورها
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    پرداخت فاکتور
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('factors/factor-print') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item href="/factors">فاکتور</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    جزییات فاکتور
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/tickets/add-ticket' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item href="/tickets">
                                    تیکت ها
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    ثبت تیکت
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/tickets/ticket-detail' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item href="/tickets">
                                    تیکت ها
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    جزییات تیکت
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/services/service-detail' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item href="/services">
                                    سرویس ها
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    جزییات سرویس
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/edit-prof' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    ویرایش اطلاعات کاربری
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/change-pass' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    تغییر کلمه عبور
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/services/server-iran' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item className={"text-muted"}>
                                    سرویس ها
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    خرید سرور ایران
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/server-europe' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item className={"text-muted"}>
                                    سرویس ها
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    خرید سرور اروپا
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName === '/services/server-iran/server-order' &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="#">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item className={"text-muted"}>
                                    سرویس ها
                                </Breadcrumb.Item>
                                <Breadcrumb.Item href="/services/server-iran" className={"text-muted"}>
                                    خرید سرور ایران
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>
                                    سفارش
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }
                            {
                                pathName === '/server-europe/server-order' &&
                                <Breadcrumb className={"f-12 py-2"}>
                                    <Breadcrumb.Item href="#">داشبورد</Breadcrumb.Item>
                                    <Breadcrumb.Item className={"text-muted"}>
                                        سرویس ها
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item href="/services/server-iran" className={"text-muted"}>
                                        خرید سرور اروپا
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active className={"text-muted"}>
                                        سفارش
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            }
                            {/*{*/}
                            {/*    pathName === '/services/server-europe/server-order/card' &&*/}
                            {/*    <Breadcrumb className={"f-12 py-2"}>*/}
                            {/*        <Breadcrumb.Item href="#">داشبورد</Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item className={"text-muted"}>*/}
                            {/*            سرویس ها*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item className={"text-muted"}>*/}
                            {/*            خرید سرور اروپا*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item className={"text-muted"}>*/}
                            {/*            سفارش*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item active className={"text-muted"}>*/}
                            {/*            سبد خرید*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*    </Breadcrumb>*/}
                            {/*}*/}
                            {/*{*/}
                            {/*    pathName === '/services/server-iran/server-order/card' &&*/}
                            {/*    <Breadcrumb className={"f-12 py-2"}>*/}
                            {/*        <Breadcrumb.Item href="#">داشبورد</Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item className={"text-muted"}>*/}
                            {/*            سرویس ها*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item className={"text-muted"}>*/}
                            {/*            خرید سرور ایران*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item className={"text-muted"}>*/}
                            {/*            سفارش*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*        <Breadcrumb.Item active className={"text-muted"}>*/}
                            {/*            سبد خرید*/}
                            {/*        </Breadcrumb.Item>*/}
                            {/*    </Breadcrumb>*/}
                            {/*}*/}
                            {
                            pathName.includes('/servers/vps') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>سرور مجازی VPS
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/vds') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>سرور اختصاصی مجازی VDS
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/datacrunch') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>سرور گرافیکی</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/host-shop') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>هاست فروشگاهی</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/host-prestashop') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>هاست پرستاشاپ</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/host-wordpress') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>هاست وردپرس</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/host-organization') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>هاست سازمانی</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/host-gitlab') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>هاست GitLab</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/host-finance') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>هاست حسابداری و مالی</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/voip') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>سرور VoIP</Breadcrumb.Item>
                            </Breadcrumb>
                        }{
                            pathName.includes('/servers/hetzner') &&
                            <Breadcrumb className={"f-12 py-2"}>
                                <Breadcrumb.Item href="/">داشبورد</Breadcrumb.Item>
                                <Breadcrumb.Item active className={"text-muted"}>سرور هتزنر</Breadcrumb.Item>
                            </Breadcrumb>
                        }

                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Toolbar;